import React, { useState } from "react";
import axios from "axios";
import { BASE_URL } from "../BaseUrl";
import { getCookie } from "../functions/Functions";

const AuditContext = React.createContext();

const AuditProvider = ({ children }) => {
  // Loading states
  const [loading, setLoading] = useState(false);
  const [dataPaginating, setDataPaginating] = useState(false);

  // RCR Sections
  const [rcrSections, setRcrSections] = useState(null);
  
  // RCR Audits
  const [rcrAuditList, setRcrAuditList] = useState(null);
  const [rcrAuditListForSearch, setRcrAuditListForSearch] = useState(null);
  
  // RCR Questions
  const [rcrQuestionList, setRcrQuestionList] = useState(null);
  const [rcrQuestionListForSearch, setRcrQuestionListForSearch] = useState(null);

  // Complaint Categories, Resolution Types, Departments
  const [complaintCategories, setComplaintCategories] = useState(null);
  const [complaintResolutionTypes, setComplaintResolutionTypes] = useState(null);
  const [complaintDepartments, setComplaintDepartments] = useState(null);
  const [complaintCauses, setComplaintCauses] = useState(null);

  const getComplaintCategories = async () => {
    setLoading(true);
    const url = BASE_URL + "/complaints/categories";
    try {
      const res = await axios.get(url, {
        headers: {
          "Authorization": `Bearer ${getCookie()}`
        },
      });
      setComplaintCategories(res.data[1]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getComplaintResolutionTypes = async () => {
    setLoading(true);
    const url = BASE_URL + "/complaints/resolution-types";
    try {
      const res = await axios.get(url, {
        headers: {
          "Authorization": `Bearer ${getCookie()}`
        },
      });
      setComplaintResolutionTypes(res.data[1]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getComplaintDepartments = async () => {
    setLoading(true);
    const url = BASE_URL + "/complaints/departments";
    try {
      const res = await axios.get(url, {
        headers: {
          "Authorization": `Bearer ${getCookie()}`
        },
      });
      setComplaintDepartments(res.data[1]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getComplaintCauses = async () => {
    setLoading(true);
    const url = BASE_URL + "/complaints/causes";
    try {
      const res = await axios.get(url, {
        headers: {
          "Authorization": `Bearer ${getCookie()}`
        },
      });
      if (res.data && res.data[1]) {
        setComplaintCauses(res.data[1]);
      } else {
        setComplaintCauses(res.data?.data || res.data || []);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getRcrSections = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/sections";
    try {
      const res = await axios.get(url, {
        headers: {
          "Authorization": `Bearer ${getCookie()}`
        },
      });
      if (res.data && res.data[1]) {
        setRcrSections(res.data[1]);
      } else {
        setRcrSections(res.data?.data || []);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // get paginated RCR Audits
  const getPaginatedRcrAudits = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/audits";
    try {
      const res = await axios.get(url, {
        params: {
          page: pageNo
        },
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setRcrAuditList(res.data[0]);
      setRcrAuditListForSearch(res.data[1]);
      setDataPaginating(false);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // get paginated RCR Questions
  const getPaginatedRcrQuestions = async (searchPayload = {}) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/admin-questions";
    try {
      const res = await axios.get(url, {
        params: searchPayload,
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res.data && res.data.length > 0) {
        setRcrQuestionList(res.data[0]);
        setRcrQuestionListForSearch(res.data[1]);
      }
      setDataPaginating(false);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  return (
    <AuditContext.Provider
      value={{
        loading,
        setLoading,
        dataPaginating,
        setDataPaginating,
        rcrSections,
        setRcrSections,
        rcrAuditList,
        setRcrAuditList,
        rcrAuditListForSearch,
        setRcrAuditListForSearch,
        rcrQuestionList,
        setRcrQuestionList,
        rcrQuestionListForSearch,
        setRcrQuestionListForSearch,
        complaintCategories,
        setComplaintCategories,
        complaintResolutionTypes,
        setComplaintResolutionTypes,
        complaintDepartments,
        setComplaintDepartments,
        complaintCauses,
        setComplaintCauses,
        getRcrSections,
        getPaginatedRcrAudits,
        getPaginatedRcrQuestions,
        getComplaintCategories,
        getComplaintResolutionTypes,
        getComplaintDepartments,
        getComplaintCauses,
      }}
    >
      {children}
    </AuditContext.Provider>
  );
};

export { AuditProvider, AuditContext };
